module.exports = __webpack_public_path__ + "static/media/Do-Thanh-Ha.2ea5dfe8.png";